import React from 'react';
import { Slider, Space } from 'antd';
import { colors, dimensions } from '../../../theme';

type SliderControlProps = {
  value: number; // 0..max
  onChange: (value: number) => void;
  onChangeComplete?: (value: number) => void;
  max?: number; // default 1
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  width?: number;
  title?: string;
};

export const SliderControl: React.FC<SliderControlProps> = ({
  value,
  onChange,
  onChangeComplete,
  max = 1,
  iconLeft,
  iconRight,
  width = 100,
  title
}) => (
  <Space
    align='center'
    size={dimensions.spacing.md}
    style={{
      padding: `${dimensions.spacing.sm}px ${dimensions.spacing.xl}px`,
      borderRadius: dimensions.radius.pill,
      backgroundColor: colors.surfaceElevated
    }}
    title={title}
  >
    {iconLeft && <span style={{ color: colors.textSecondary, display: 'flex' }}>{iconLeft}</span>}
    <Slider
      min={0}
      max={max}
      step={0.01}
      value={value}
      onChange={onChange}
      onChangeComplete={onChangeComplete}
      style={{ width, margin: 0 }}
      styles={{
        handle: { borderColor: '#722ed1', boxShadow: '0 2px 8px #722ed1' },
        track: { backgroundColor: colors.playheadTrack },
        rail: { backgroundColor: colors.playheadRail }
      }}
    />
    {iconRight && <span style={{ color: colors.textSecondary, display: 'flex' }}>{iconRight}</span>}
  </Space>
);
